import { datadogLogs } from '@datadog/browser-logs';
import React, { useEffect } from 'react';
export const LoggerAgent = React.memo(function LoggerAgent({ session, isWindowsApp, }) {
    useEffect(() => {
        if (session) {
            datadogLogs.setUser({
                id: session.id,
                name: session.name ?? '',
                email: session.email,
            });
            datadogLogs.setGlobalContextProperty('isPro', session.isPro);
            datadogLogs.setGlobalContextProperty('tier', session.tier);
            datadogLogs.setGlobalContextProperty('isEnterprise', session.isEnterprise);
            datadogLogs.setGlobalContextProperty('isWindowsApp', isWindowsApp);
        }
    }, [session, isWindowsApp]);
    return null;
});
//# sourceMappingURL=LoggerAgent.js.map